import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputArticlePricesSetSimplePrice } from './InputArticlePricesSetSimplePrice.entity';
import { InputArticlePurchasePrice } from './InputArticlePurchasePrice.entity';

export class InputArticlePrices<T extends EMode = EMode.entity> {
  /** Alias: simplePrices */
  simplePrices?: InputArticlePricesSetSimplePrice<T>[];
  /** Alias: purchasePrices */
  purchasePrices?: InputArticlePurchasePrice<T>;

  __typename?: string;
}

const fields: FieldDefinitions<InputArticlePrices> = {
  simplePrices: {
    alias: 'simplePrices',
  },
  purchasePrices: {
    alias: 'purchasePrices',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputArticlePricesEntityDefinition: EntitiyDefinition<InputArticlePrices> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputArticlePrices',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
